module.exports = __webpack_public_path__ + "media/epic.2d52d941.mp4";